<template>
    <div class="report-data-area-box">
        <div class="report-data-area" v-bind:id="canvasId"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportDataArea',
    props: ['canvasId', 'xDataArr', 'yDataArr'],
    mounted() {
		var me = this;
        setTimeout(() => {
			me.initEcharts();
        }, 100);
    },
    methods: {
        initEcharts() {
            var me = this;
            var canvasDom = document.getElementById(this.canvasId);
            if(canvasDom == null) { return; }
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(canvasDom);
            console.log('init-------', echarts, me.xDataArr, me.yDataArr)
            // 绘制图表
            myChart.setOption({
                xAxis: {
                    type: 'category',
                    show: true,
                    data: me.xDataArr,
                    axisLabel: {
                        color: '#BB7C55',
                        fontSize: 8.5
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#EAC96B'
                        }
                    },
                },
                yAxis: {
                    min: 70, max: 100,
                    type: 'value',
                    show: true,
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#EAC96B'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#EAC96B'
                        }
                    }
                },
                grid: {
                    show: true,
                    borderColor: '#EAC96B',
                    bottom: '3%',
                    containLabel: true,
                },
                series: [{
                    data: me.yDataArr,
                    type: 'line',
                    symbol: 'circle',
                    symbolSize: 6,
                    smooth: true,
                    lineStyle: {
                        color: '#E02020'
                    },
                    itemStyle : {
                        normal : {
                            color:'#E02020',
                            lineStyle:{
                                color:'#E02020'
                            }
                        }
                    }
                }]
            });
            // console.log('initEcharts------', this.canvasId, canvasDom, echarts)
        }
    }
}
</script>